module.exports = __webpack_public_path__ + "static/img/index-bg-shengping.572e78c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index-bg-shengping.jpg
// module id = fK5y
// module chunks = 0